import { animate, query, stagger, state, style, transition, trigger } from '@angular/animations';

export const CUBIC_BEZIER_DEFAULT = 'cubic-bezier(0.35, 0, 0.25, 1)';
export const CUBIC_BEZIER_BOUNCE = 'cubic-bezier(0.71, 1.7, 0.77, 1.24)';
export const ANIMATION_DURATION = 300;
const ANIMATION_TIMINGS = `${ANIMATION_DURATION}ms ${CUBIC_BEZIER_DEFAULT}`;

export const leftToRightAnimation = trigger('slideContentToLeft', [
    state('void', style({ transform: 'translateX(100%)' })),
    state('enter', style({ transform: 'translateX(0)' })),
    state('leave', style({ transform: 'translateX(100%)' })),
    transition('* => enter', [animate(ANIMATION_TIMINGS)]),
    transition('* => leave', [animate(ANIMATION_TIMINGS)], {
        delay: '50ms'
    })
]);

export const rightToLeftAnimation = trigger('slideContentToRight', [
    state('void', style({ transform: 'translateX(-100%)' })),
    state('enter', style({ transform: 'translateX(0)' })),
    state('leave', style({ transform: 'translateX(-100%)' })),
    transition('* => enter', [animate(ANIMATION_TIMINGS)]),
    transition('* => leave', [animate(ANIMATION_TIMINGS)], {
        delay: '50ms'
    })
]);

export const foldOutTransition = trigger('foldout', [
    state(
        'void',
        style({
            height: 0,
            overflow: 'hidden'
        })
    ),
    state(
        'open',
        style({
            height: '*'
        })
    ),
    state(
        'closed',
        style({
            height: 0
        })
    ),
    transition('closed <=> open', animate('200ms ease-in'))
]);

export const fadeTransition = trigger('fadeIn', [
    transition(':enter', [style({ opacity: 0 }), animate(ANIMATION_DURATION)]),
    transition(':leave', [animate(ANIMATION_DURATION, style({ opacity: 0 }))]),
    state('*', style({ opacity: 1 }))
]);

export const easeInOutAnimation = trigger('easeInOut', [
    transition(':enter', [
        style({ height: 0, overflow: 'hidden', opacity: 0 }),
        animate('200ms ease-in', style({ height: '*', opacity: 1 }))
    ]),
    transition(':leave', [
        style({ height: '*', opacity: 1 }),
        animate('200ms ease-out', style({ height: 0, overflow: 'hidden', opacity: 0 }))
    ])
]);

export const slideInOutAnimation = trigger('slideInOut', [
    transition(':enter', [
        style({ transform: 'translateY(100%)' }),
        animate('500ms 500ms ease-in', style({ transform: 'translateY(0%)' }))
    ]),
    transition(':leave', [animate('500ms ease-in', style({ transform: 'translateX(-100%)' }))])
]);

export const flyInLeftAnimation = trigger('flyInLeft', [
    transition('* => *', [
        query(
            ':enter',
            [
                style({ opacity: 0, transform: 'translateX(100px)' }),
                stagger(20, [animate('300ms cubic-bezier(0.35, 0, 0.25, 1)', style({ opacity: 1, transform: 'none' }))])
            ],
            { optional: true }
        )
    ])
]);

export const scaleUpAnimation = trigger('scaleUp', [
    transition('* => *', [
        query(
            ':enter',
            [
                style({ opacity: 0, transform: 'scale(0.9)' }),
                stagger(20, [
                    animate('300ms cubic-bezier(0.35, 0, 0.25, 1)', style({ opacity: 1, transform: 'scale(1)' }))
                ])
            ],
            { optional: true }
        )
    ])
]);

export const scaleAndFade = trigger('scaleAndFade', [
    transition(':enter', [
        style({ opacity: 0, transform: 'scale(0)' }),
        animate('200ms cubic-bezier(0.35, 0, 0.25, 1)', style({ opacity: 1, transform: 'scale(1)' }))
    ]),
    transition(':leave', [
        animate('200ms cubic-bezier(0.35, 0, 0.25, 1)', style({ opacity: 0, transform: 'scale(0)' }))
    ])
]);

export const fadeInOut = trigger('fadeInOut', [
    state('in', style({ opacity: 1 })),
    state('out', style({ opacity: 0 })),
    transition('in <=> out', [animate('200ms linear')])
]);

/* animations based on :enter and :leave instead of states */
export const slideToLeftAnimation = trigger('slideToLeft', [
    transition(':enter', [
        style({ transform: 'translateX(100%)', opacity: 0, position: 'absolute', top: 0, width: '100%' }),
        animate(ANIMATION_TIMINGS, style({ transform: 'translateX(0)', opacity: 1 }))
    ]),
    transition(':leave', [animate(ANIMATION_TIMINGS, style({ opacity: 0 }))])
]);
